import { useTranslation } from 'react-i18next'
import ProductsComponent from '../components/Products'

export default function Products() {
  const { t } = useTranslation()

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="relative min-h-[400px] md:min-h-[500px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(226, 114, 91, 0.85), rgba(226, 114, 91, 0.85)), url('https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-4.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container mx-auto px-4 md:px-8 lg:px-12 text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {t('productsPage.hero.title')}
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
            {t('productsPage.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* Products Section */}
      <ProductsComponent />

      {/* Info Section */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-[#FFDB58]/10 to-white">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-4 font-elegant">
                {t('productsPage.whyChoose.title')}
              </h2>
              <div className="elegant-divider mx-auto mb-8" style={{ maxWidth: '200px' }}></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-[#4D5D33]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-[#4D5D33]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-[#333333] mb-3 font-elegant">{t('productsPage.whyChoose.feature1.title')}</h3>
                <p className="text-[#333333]/70">
                  {t('productsPage.whyChoose.feature1.description')}
                </p>
              </div>

              <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-[#E2725B]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-[#E2725B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-[#333333] mb-3 font-elegant">{t('productsPage.whyChoose.feature2.title')}</h3>
                <p className="text-[#333333]/70">
                  {t('productsPage.whyChoose.feature2.description')}
                </p>
              </div>

              <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-[#FFDB58]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-[#333333]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-[#333333] mb-3 font-elegant">{t('productsPage.whyChoose.feature3.title')}</h3>
                <p className="text-[#333333]/70">
                  {t('productsPage.whyChoose.feature3.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

